module.exports = __webpack_public_path__ + "static/media/new-ringtone.37cca943.mp3";